// A generation marks the lifetime of asynchronous work for one sign-in.
// Logout invalidates it before clearing data, so late results cannot repopulate stores.
let generation = 0;
const cleanupTasks = new Set<() => void>();

export const getSessionGeneration = () => generation;
export const isSessionGenerationCurrent = (value: number) => value === generation;

export function registerSessionCleanup(task: () => void): () => void {
  cleanupTasks.add(task);
  return () => {
    cleanupTasks.delete(task);
  };
}

export function invalidateSessionWork(): void {
  generation += 1;
  cleanupTasks.forEach((task) => task());
}
